import { StudyPrefetcherService } from './StudyPrefetcherService';

export { StudyPrefetcherService as default, StudyPrefetcherService };
